var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596168",
    fillRule: "evenodd",
    d: "M.665 11.505a2.59 2.59 0 01.65-1.089l7.322-7.321a.324.324 0 01.458 0l1.81 1.81a.324.324 0 010 .458l-7.322 7.322a2.595 2.595 0 01-1.089.65l-2.181.655a.243.243 0 01-.303-.303l.655-2.182zM13.695 1.26a1.04 1.04 0 010 1.472L12.53 3.898a.347.347 0 01-.49.001l-1.937-1.938a.347.347 0 010-.49L11.268.304a1.04 1.04 0 011.47-.002l.957.958z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default ForwardRef;